
import * as Accountant from 'app/calcs/Accountant'
import * as TX from 'app/calcs/Accountant/Transactions/interfaces'
import { INEBFPensionInputs } from 'app/calcs/customers/NEBF/interfaces'
import { CommonPensionCalculations } from 'app/calcs/pensions'
import { ICommonPensionInputs, IMonthlyPensionPayments, SimplePensionFormOfPayment } from 'app/calcs/pensions/interfaces'
import { cachedNEBFRunCalculations } from 'app/redux/Customers/NEBF/actions'
import { ageAtAsDuration, deadBy, IRetirementPerson, Profile } from 'app/redux/Profile/model'
import * as utils from 'app/utils'
import { makeNEBFPaymentExtractor } from 'app/workbookDAOs/NEBFDAO'
import * as _ from 'lodash'
import * as moment from 'moment'

class NEBFPensionCalculations extends CommonPensionCalculations<INEBFPensionInputs> {

  protected spouse: IRetirementPerson

  constructor(profile: Profile, pensionText: string) {
    super(profile, pensionText)
  }

  getMonthlyPensionAmount(member: IRetirementPerson, vals: INEBFPensionInputs, when: moment.Moment): Promise<IMonthlyPensionPayments> {

    const spouse = this.spouse
    const shared = this.profile.pension.shared
    return cachedNEBFRunCalculations({ member, spouse, vals, shared, when: null })
    .then(makeNEBFPaymentExtractor(vals, when))
    .then((baseAmount) => {
      // tslint:disable-next-line:no-console
      //console.log('NEBF amount at ' + when.format('L') + ' is ' + amount + ', vals: ' + JSON.stringify(vals))
      const kind = vals.formOfPayment as SimplePensionFormOfPayment
      return this.calculateSimplePension(when, baseAmount, kind, false)
    })
  }

  getPension(): INEBFPensionInputs {
    return this.profile.pension.NEBF
  }

  getPerson(): IRetirementPerson {
    return this.profile.getHeadOfHousehold()
  }

  getTimeLineTransactions(): Promise<TX.ITransactionItem[]> {
    this.setSpouse(this.profile.getSpouse())
    return super.getTimeLineTransactions()
  }

  getTransactions(when: moment.Moment, tolerance: TX.TransactionTolerance = 'month'): Promise<TX.ITransactionItem[]> {
    this.setSpouse(this.profile.getSpouse())
    return super.getTransactions(when, tolerance)
  }

  setSpouse(spouse: IRetirementPerson) {
    this.spouse = spouse
  }
}

export {
  NEBFPensionCalculations
}



// WEBPACK FOOTER //
// ./src/app/calcs/customers/NEBF/index.ts